import React from 'react';
import PropTypes from 'prop-types';

/**
Il ButtonGroup serve per raggruppare un insieme di bottoni spaziandoli corretamente tra di loro ed evitando l'effetto assembramento
 */
const ButtonGroup = ({ children }) => (
  <div className="buttonGroup">
    {children}
  </div>
);

ButtonGroup.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ButtonGroup.defaultProps = {
  children: null,
};

export default ButtonGroup;
